define('controllers/edithotelroomsanddescriptions',['require','lazyload'],function (require) {
    require('lazyload');
	return function() {
		$(function () {
			$("form").attr("target", "uploadTrg")
					 .attr("enctype", "multipart/form-data"); //set form to be posted via the iframe, so we can upload without full page refresh...

			var ajax_Url = "editRoomAndDescription.aspx",
				iframeErrorMessage = null,
				iframeInfoMessage = null;

			var adestForm = document.forms['form1'];
			if (!adestForm) {
				adestForm = document.form1;
			}
			function submitForm(eventTarget, eventArgument) {
				if (!adestForm.onsubmit || (adestForm.onsubmit() != false)) {
					adestForm.adest_eventTarget.value = eventTarget;
					adestForm.adest_eventArgument.value = eventArgument;
					adestForm.submit();
				}
			}

			$("input[data-roomId]").click(function () {
				var $this = $(this),
					$roomContainer = $this.parent(),
					roomId = $this.attr("data-roomId"),
					roomName = $(".Name", $roomContainer).val(),
					roomDescription = $(".Description", $roomContainer).val(),
					fu_CustomerImage = $(".fu_CustomerImage", $roomContainer),
					RemoveImage = $(".RemoveImage", $roomContainer),
					uploadingImage = fu_CustomerImage.val().length > 0,
					deleting = $this.hasClass("deleteRoom");
					postData = JSON.stringify({
						rid: roomId,
						name: roomName,
						description: Utilities.htmlEncode(roomDescription),
						fileUpload_Name: fu_CustomerImage.attr("name"),
						removeImage: RemoveImage.is(":checked")
					});

				if (uploadingImage && !deleting) {
					$("input[data-roomId]").prop('disabled', true); //simply disable all input buttons, when uploading image (posting via the same iframe)
					iframeErrorMessage = $(".alert-error", $roomContainer);
					iframeInfoMessage = $(".alert-info", $roomContainer);
					submitForm('uploadCustomerImage', postData);
				} else {
					var errorMessage = $(".alert-error", $roomContainer),
						infoMessage = $(".alert-info", $roomContainer);

					$this.prop('disabled', true);
					errorMessage.hide();
					infoMessage.hide();

					$.ajax({
						type: 'POST',
						url: ajax_Url,
						data: { method: deleting ? "DeleteRoom" : "SaveRoom", serializedHotelData: postData },
						success: function (error) {
							if (error != "") {
								errorMessage.show().html(error);
							} else {
								errorMessage.hide();
								infoMessage.show().html("Successfully {0} room".format(deleting ? "deleted" : "updated"));
							}
							$this.prop('disabled', false);
						},
						error: function () {
							errorMessage.show().html("Something went wrong. Please re-load the page and try again or contact Adestinn Support.");
							$this.prop('disabled', false);
						}
					});
				}
			});

			$("iframe").on("load", roomImageUploaded);
			function roomImageUploaded() {
				if (iframeInfoMessage != null) {
					$.post(ajax_Url, { method: "CheckSaveStatus" }, function (errorMsg) {
						//TODO: create image element if all is well...
						//TODO: delete image element if removing image...

						if (errorMsg == "OK") {
							iframeInfoMessage.show().text("Successfully updated room and image");
						} else if (errorMsg.length > 0) {
							iframeErrorMessage.show().text(errorMsg);
						} else {
							iframeErrorMessage.show().text("Something went wrong while attempting to save the room data.");
						}
						$("input[data-roomId]").prop('disabled', false);
						iframeInfoMessage = null;
						iframeErrorMessage = null;
					});
				}
			}

			Utilities.lazyLoad();

			$('#deleteAllRooms').on('click', function () {
				var $this = $(this);
				$this.prop('disabled', true);

				var hotelId = parseInt(requestQueryString('hid'));
				$.post(ajax_Url, { method: "DeleteAllRooms", hotelId: hotelId }).then(function (response) {
					if (response.error) {
						alert(response.error);
						console.log(response.error);
						return;
					}
					$this.text('{0} Rooms Deleted, reloading availability...'.format(response));
					window.location.reload(); //reload the page so that it gets room availability again.
				});
			});
		});
	};
});
